import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import _omit from 'lodash/omit';
import NumberFormat from 'react-number-format';
import sanitizeHtml from 'sanitize-html';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// Components
import Loader from '../utils/Loader';
import ImageUploader from '../utils/ImageUploader';

// CSS
import '../../css/react-select.css';

// State
import { addRoute } from '../../store/actions/route';
import { setpageTitle, getSiteInfo } from '../../store/actions/siteInfo';
import { userTokenUpdate } from '../../store/actions/user';
import { getLocations, getProvinces } from '../../store/actions/locations';
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../shared/vars';

// Utils
import { deleteTempImages } from '../../utils/uploadHelpers';

class AdminPickupSettings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            data: {},

            error: '',
            updateLoading: false,
            updateSuccess: '',
            updateErrors: {},
            promiseCollection: [],
        };

        this.props.addRoute(this.props.match);
        this.props.setpageTitle('Pickup Settings');
    }

    componentDidMount() {
        this.props.getLocations();
        this.loadData();
    }

    loadData() {
        this.setState({
            isLoading: true,
            data: {},
        });

        this.props.getSiteInfo();

        const AUTH_HEADER = {
            Authorization: REACT_APP_SITE_KEY + ':Bearer ' + this.props.user.token,
        };
        return axios
            .get(REACT_APP_API_URL + 'pickup_settings', { headers: AUTH_HEADER })
            .then((response) => {
                if (
                    response.status !== 200 ||
                    (response.data.status && response.data.status !== 200)
                ) {
                    this.setState({ isLoading: false, error: response.data.message });
                } else {
                    let dummy = '2020-01-01 ';
                    let day_names = [
                        'monday',
                        'tuesday',
                        'wednesday',
                        'thursday',
                        'friday',
                        'saturday',
                        'sunday',
                    ];
                    let input_days = {};
                    let output_days = {};
                    day_names.map((name) => {
                        input_days[name] = { start: null, end: null };
                        output_days[name] = { start: null, end: null };
                    });
                    response.data.days.map((record) => {
                        input_days[record.day] = {
                            start: record.start ? new Date(dummy + record.start) : null,
                            end: record.end ? new Date(dummy + record.end) : null,
                        };
                        output_days[record.day] = {
                            start: record.start,
                            end: record.end,
                        };
                    });
                    response.data.input_days = input_days;
                    response.data.days = output_days;

                    // Time is put below otherwise there's an issue where it gets the wrong date
                    response.data.input_closed = response.data.closed.map(
                        (record) => new Date(record.day + ' 00:00:00')
                    );

                    response.data.closed = response.data.closed.map(
                        (record) => record.day
                    );

                    this.setState({
                        isLoading: false,
                        data: response.data,
                    });
                }
            })
            .catch((err) => {
                if (err.response) {
                    this.setState({
                        isLoading: false,
                        error: err.response.data.errors
                            ? err.response.data.errors
                            : err.response.data.message,
                    });
                } else {
                    this.setState({ isLoading: false, error: err.message });
                }
            });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.default_country !== null && this.state.data.country === '') {
            this.setState({
                data: {
                    ...this.state.data,
                    country: nextProps.default_country,
                },
            });
        }
    }

    updateSelectedCountry = (country, id) => {
        this.setState(
            {
                data: {
                    ...this.state.data,
                    [id]: country.id,
                    province: '',
                },
            },
            () => this.props.getProvinces(this.state.data[id])
        );
    };

    updateSelectedProvince = (province, id) => {
        this.setState({
            data: {
                ...this.state.data,
                [id]: province.abbreviation,
            },
        });
    };

    handleInputChange(event) {
        const { id, value } = event.target;
        this.setState({
            data: {
                ...this.state.data,
                [id]: value,
            },
        });
    }

    handleTimeChange(day, date, key) {
        let state = this.state;
        if (!date) {
            state.data.days[day.toLowerCase()].start = null;
            state.data.days[day.toLowerCase()].end = null;
            state.data.input_days[day.toLowerCase()].start = null;
            state.data.input_days[day.toLowerCase()].end = null;
        } else {
            state.data.days[day.toLowerCase()][key] =
                date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
            state.data.input_days[day.toLowerCase()][key] = date;
        }
        this.setState(state);
    }

    handleClosedChange(date, index) {
        let state = this.state;
        if (!date) {
            state.data.input_closed = state.data.input_closed.filter(
                (e, i) => i != index
            );
            state.data.closed = state.data.closed.filter((e, i) => i != index);
        } else {
            state.data.input_closed[index] = date;
            // date.getMonth() starts at zero, so plus 1 for proper dates
            state.data.closed[index] =
                date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        }
        this.setState(state);
    }

    handleClosedAdd(date) {
        let state = this.state;
        console.log(date);
        state.data.input_closed.push(date);
        // date.getMonth() starts at zero, so plus 1 for proper dates
        state.data.closed.push(
            date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
        );
        this.setState(state);
    }

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            this.handleSubmit();
        }
    }

    handleNumberChange(id, valueObject) {
        this.setState({
            data: {
                ...this.state.data,
                [id]: valueObject.value,
            },
        });
    }

    handleShippingChange(country, valueObject) {
        this.setState({
            data: {
                ...this.state.data,
                shipping: [
                    ...this.state.data.shipping.map((shipItem) => {
                        if (shipItem.id !== country) return shipItem;
                        shipItem.cost = valueObject.value;
                        return shipItem;
                    }),
                ],
            },
        });
    }

    handleRadioClick(event, name) {
        const { value } = event.target;
        this.setState({
            data: {
                ...this.state.data,
                [name]: value,
            },
        });
    }

    removeExistingImage(propertyName, dataPropName) {
        this.setState({
            [dataPropName]: '',
            data: {
                ...this.state.data,
                [propertyName]: '',
            },
        });
    }

    // ===================================================================================
    //  SUBMIT
    // ===================================================================================
    handleSubmit() {
        // Set the state to let everything know that submitting is happening
        // We need to wait for this to actually complete and utilize the callback so any uploaders
        // actually know that they should begin uploading
        this.setState(
            {
                updateSuccess: '',
                updateErrors: {},
                updateLoading: true,
            },
            () => {
                // Wait until all uploader promises have completed
                Promise.all(this.state.promiseCollection)
                    .then((resolves) => {
                        // console.log('ok parent:', resolves)

                        this.setState({
                            promiseCollection: [],
                        });

                        this.completeSubmit(resolves);
                    })
                    .catch((err) => {
                        // console.log('err parent:', err)
                        this.setState({
                            updateLoading: false,
                            promiseCollection: [],
                        });
                    });
            }
        );
    }

    completeSubmit(resolves) {
        const { user } = this.props;
        const { data } = this.state;
        let uploadedUrls = [];

        // If there are uploads, grab specific info from them for the new images
        if (!!resolves) {
            resolves.forEach((resolve) => {
                if (!resolve) return;
                const upload = resolve[0];
                data[upload.type] = upload.results;

                uploadedUrls.push(upload.results);
            });
        }

        const token = user.token;
        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + token };
        return axios
            .post(REACT_APP_API_URL + 'pickup_settings', data, { headers: AUTH_HEADER })
            .then((response) => {
                if (
                    response.status !== 200 ||
                    (response.data.status && response.data.status !== 200)
                ) {
                    this.setState({
                        updateLoading: false,
                        updateErrors: !isEmpty(response.data.errors)
                            ? response.data.errors
                            : { general: response.data.message },
                    });

                    deleteTempImages(uploadedUrls, this.props.user.token).catch((err) => {
                        console.log(err);
                    });
                } else {
                    this.setState({
                        updateLoading: false,
                        updateSuccess: response.data.message,
                    });

                    this.props.userTokenUpdate('admin', response.data.token);
                    this.loadData();
                }
            })
            .catch((err) => {
                if (err.response) {
                    this.setState({
                        updateLoading: false,
                        updateErrors: {
                            general: err.response.data.error
                                ? err.response.data.error
                                : err.response.data.message,
                        },
                    });
                } else {
                    this.setState({
                        updateLoading: false,
                        updateErrors: { general: err.message },
                    });
                }

                deleteTempImages(uploadedUrls, this.props.user.token).catch((err) => {
                    console.log(err);
                });
            });
    }

    render() {
        const { locationsLoading, locationsError, countries, provinces } = this.props;
        const {
            error,
            isLoading,
            updateLoading,
            updateErrors,
            updateSuccess,
            promiseCollection,
        } = this.state;

        const days = [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday',
        ];

        return (
            <div>
                <h1>Pickup Settings</h1>

                {/* Has error */}
                {error ? (
                    <div className="error">
                        {Object.keys(error).map((key) => (
                            <span key={key}>{error[key]}</span>
                        ))}
                    </div>
                ) : isLoading ? (
                    <div className="pt2 pb2">
                        <Loader />
                    </div>
                ) : (
                    <div>
                        <div className="tight-form-fields">
                            <div className="fieldset">
                                <div className="floated-field-container">
                                    <div className="form-field half-field">
                                        <label>Pickup Window (in Days)</label>

                                        {updateErrors.max_days && (
                                            <div className="error msg_animate">
                                                {updateErrors.max_days}
                                            </div>
                                        )}
                                        <NumberFormat
                                            id="max_days"
                                            value={this.state.data.max_days}
                                            placeholder="0"
                                            decimalScale={0}
                                            onKeyPress={(e) => this.handleKeyPress(e)}
                                            onChange={(event) =>
                                                this.handleInputChange(event)
                                            }
                                        />
                                    </div>

                                    <div className="form-field half-field">
                                        <label>Number of Appointments per Timeslot</label>

                                        {updateErrors.max_appointments && (
                                            <div className="error msg_animate">
                                                {updateErrors.max_appointments}
                                            </div>
                                        )}
                                        <NumberFormat
                                            id="max_appointments"
                                            value={this.state.data.max_appointments}
                                            placeholder="0"
                                            decimalScale={0}
                                            onKeyPress={(e) => this.handleKeyPress(e)}
                                            onChange={(event) =>
                                                this.handleInputChange(event)
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="fieldset">
                                {days.map((day) => (
                                    <div className="fieldset" key={day}>
                                        <label className="fieldset_label">{day}</label>
                                        {updateErrors[day.toLowerCase()] && (
                                            <div className="error msg_animate">
                                                {updateErrors[day.toLowerCase()]}
                                            </div>
                                        )}
                                        <div className="floated-field-container">
                                            <div className="form-field half-field">
                                                <DatePicker
                                                    selected={
                                                        this.state.data.input_days[
                                                            day.toLowerCase()
                                                        ].start
                                                    }
                                                    placeholderText="Click to set first timeslot"
                                                    onChange={(date) =>
                                                        this.handleTimeChange(
                                                            day,
                                                            date,
                                                            'start'
                                                        )
                                                    }
                                                    showTimeSelect
                                                    showTimeSelectOnly
                                                    isClearable
                                                    timeIntervals={30}
                                                    timeCaption="Time"
                                                    dateFormat="h:mm aa"
                                                />
                                            </div>

                                            <div className="form-field half-field">
                                                <DatePicker
                                                    selected={
                                                        this.state.data.input_days[
                                                            day.toLowerCase()
                                                        ].end
                                                    }
                                                    placeholderText="Click to set last timeslot"
                                                    onChange={(date) =>
                                                        this.handleTimeChange(
                                                            day,
                                                            date,
                                                            'end'
                                                        )
                                                    }
                                                    showTimeSelect
                                                    showTimeSelectOnly
                                                    isClearable
                                                    timeIntervals={30}
                                                    timeCaption="Time"
                                                    dateFormat="h:mm aa"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="fieldset">
                                <label className="fieldset_label">Closed Dates</label>
                                {updateErrors.closed && (
                                    <div className="error msg_animate">
                                        {updateErrors.closed}
                                    </div>
                                )}

                                {this.state.data.input_closed.map((day, index) => (
                                    <div className="form-field" key={day}>
                                        <DatePicker
                                            selected={day}
                                            onChange={(date) =>
                                                this.handleClosedChange(date, index)
                                            }
                                            isClearable
                                        />
                                    </div>
                                ))}

                                <div>
                                    <DatePicker
                                        onChange={(date) => this.handleClosedAdd(date)}
                                        customInput={
                                            <button className="btn">
                                                ADD A CLOSED DATE
                                            </button>
                                        }
                                    />
                                </div>
                            </div>

                            {/* ======================================================================================================================== */}

                            <div className="fieldset">
                                <div className="btn_container">
                                    {updateSuccess && (
                                        <div className="success msg_animate">
                                            {updateSuccess}
                                        </div>
                                    )}
                                    {updateErrors.general && (
                                        <div
                                            className="error msg_animate"
                                            dangerouslySetInnerHTML={{
                                                __html: sanitizeHtml(
                                                    updateErrors.general
                                                ),
                                            }}
                                        />
                                    )}
                                    <button
                                        className={
                                            'btn submit-btn' +
                                            (updateLoading ? ' loading' : '')
                                        }
                                        onClick={() => this.handleSubmit()}
                                        disabled={updateLoading}
                                    >
                                        <span>Update</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.admin,
        countries: state.locations.countries,
        default_country: state.locations.default_country,
        provinces: state.locations.provinces,
        locationsLoading: state.locations.isLoading,
        locationsError: state.locations.error,
    };
};

export default connect(
    mapStateToProps,
    { addRoute, userTokenUpdate, setpageTitle, getSiteInfo, getLocations, getProvinces }
)(AdminPickupSettings);



// WEBPACK FOOTER //
// ./src/components/admin/AdminPickupSettings.js